module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_April2020-658b11e8a6b66e6bdde1c59e0a03b8f5.pdf";